export default {
    correct_answers: "Respostas corretas",
    drag_and_drop: "Arrastar e soltar",
    drag_the_words_description: "O jogador deve escolher as palavras disponíveis e arrastar para o campo de palavras no texto, até que se utilize todas as palavras disponíveis.",
    drag_the_words_failure_message: "Que pena, você não conseguiu. Tente novamente!",
    drag_the_words_instructions: "Você verá um texto com espaços em branco e um campo com palavras para escolher. Você deve arrastar as palavras para os espaços em branco, até que não reste nenhuma palavra nas suas opções.",
    drag_the_words_success_message: "Parabéns, você acertou todas as palavras e completou o jogo!",
    drag_the_words: "Arraste as palavras",
    enigma_failure_message: "Que pena, você não conseguiu. Tente novamente.",
    enigma_instructions: "Veja as dicas e desvende os enigmas!",
    enigma_success_message: "Parabéns, você conseguiu seguir as pistas corretamente e desvendou o enigma!",
    enigma: "Enigma",
    errors: "Erros",
    example: "Exemplo",
    false: "Falso",
    fill_in_the_blanks_failure_message: "Que pena, você não conseguiu. Tente novamente!",
    fill_in_the_blanks_instructions: "O jogador deve preencher todos os espaços em branco no texto. Ao preencher todos os espaços, o jogador deve clicar em enviar para que o jogo termine.",
    fill_in_the_blanks_success_message: "Parabéns, você acertou todas as palavras e completou o jogo!",
    fill_in_the_blanks: "Preencha os espaços",
    find_the_pairs_failure_message: "Que pena, você passou do limite de erros permitido. Tente novamente.",
    find_the_pairs_instructions: "O jogador terá duas colunas e deve clicar em uma das opções de uma coluna, depois clicar em uma das opções da coluna ao lado. O jogo será finalizado quando todas as opções forem selecionadas.",
    find_the_pairs_success_message: "Parabéns, você conseguiu encontrar os pares corretamente!",
    find_the_pairs: "Encontre os pares",
    flashcards_failure_message: "Que pena, você não conseguiu. Tente novamente.",
    flashcards_instructions: "O jogador deverá adicionar uma resposta para cada flashcard, até que complete o jogo.",
    flashcards_success_message: "Parabéns, você acertou todos os cartões!",
    flashcards: "Flashcards",
    forfeit: "Desistir",
    game_type: "Tipo de jogo",
    games: "Jogos",
    infinite: "Infinito",
    instructions: "Instruções",
    play_again: "Jogar novamente",
    play: "Jogar",
    qty_errors_allowed: "Quantidade de erros permitida",
    restart: "Reiniciar",
    result: "Resultado",
    that: "Aquilo",
    this_or_that_failure_message: "Que pena, você não conseguiu. Tente novamente.",
    this_or_that_instructions: "O jogador verá uma descrição e deverá escolher a opção 'isso' ou 'aquilo', até que marque todas as opções disponíveis.",
    this_or_that_success_message: "Parabéns, você acertou Isso ou Aquilo corretamente!",
    this_or_that: "Isso ou aquilo",
    this: "Isso",
    tip: "Dica",
    true_or_false_failure_message: "Que pena, você não conseguiu. Tente novamente.",
    true_or_false_instructions: "Escolha a opção verdadeiro ou falso para cada uma das frases.",
    true_or_false_success_message: "Parabéns, você acertou Verdadeiro ou Falso corretamente!",
    true_or_false: "Verdadeiro ou falso",
    true: "Verdadeiro",
    words: "Palavras",
}